import React from 'react';

const DiagnosticContext = React.createContext({});

export const DiagnosticProvider = DiagnosticContext.Provider;
export default DiagnosticContext;